<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/intro">Intro</router-link> |
    <router-link to="/quiz01">Quiz</router-link> |
    <router-link to="/reference">Reference</router-link> |
    <router-link to="/thanks">Thanks</router-link> |
    <router-link to="/credit">Credit</router-link>
  </nav> -->
  <div class="japanese-toggle">
    <p class="japanese-on">日本語表示</p>
    <label class="switch__label">
      <input type="checkbox" class="switch__input" v-model="japanese" />
      <span class="switch__content"></span>
      <span class="switch__circle"></span>
    </label>
  </div>
  <router-view :isJapanese="japanese" />
</template>

<script>
export default {
  data() {
    return {
      japanese: false,
    };
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  margin: 0;
}
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.japanese-on {
  color: #000;
}
.japanese-text {
  margin-top: 0;
}
.japanese-toggle {
  position: fixed;
  top: 0;
  right: 10px;
  z-index: 100;
  p {
    font-size: 0.8rem;
    margin-bottom: 0;
  }
}
.switch {
  &__label {
    width: 50px;
    position: relative;
    display: inline-block;
  }
  &__content {
    display: block;
    cursor: pointer;
    position: relative;
    border-radius: 30px;
    height: 25px;
    overflow: hidden;
    &:before {
      content: "";
      display: block;
      position: absolute;
      width: calc(100% - 3px);
      height: calc(100% - 3px);
      top: 0;
      left: 0;
      border: 1.5px solid #e5e5ea;
      border-radius: 30px;
      background-color: #fff;
    }
    &:after {
      content: "";
      display: block;
      position: absolute;
      background-color: transparent;
      width: 0;
      height: 0;
      top: 50%;
      left: 50%;
      border-radius: 30px;
      transition: all 0.5s;
    }
  }
  &__input {
    display: none;
    &:checked ~ .switch__circle {
      left: 27px;
    }
    &:checked ~ .switch__content:after {
      background-color: #34aaf2;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  &__circle {
    display: block;
    top: 2px;
    left: 2px;
    position: absolute;
    box-shadow: 0 2px 6px #999;
    width: 21px;
    height: 21px;
    border-radius: 20px;
    background-color: #fff;
    transition: all 0.5s;
  }
}
.main-frame {
  height: 100vh;
  min-height: 100vh;
}
.container {
  max-width: 980px;
  margin: 0 auto;
  height: 100%;
}
.items-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.text-image,
.japanese-text {
  width: 80%;
}
.button {
  width: fit-content;
  padding: 16px 36px;
  margin-top: 30px;
  border-radius: 8px;
  box-shadow: 0 6px 0 hsl(200deg 37% 50%), 0 12px 0 rgba(0, 0, 0, 0.2);
  text-decoration: none;
  font-size: 1.2rem;
  transition: color 0.3s, background 0.3s, box-shadow 0.3s, transform 0.3s;
  &__blue {
    background-color: #34aaf2;
    color: #fff;
  }
  &__gray {
    position: fixed;
    top: calc(100vh - 60px);
    left: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    border-radius: 8px;
    text-decoration: none;
    background-color: white;
    border: 1px solid gray;
    transition: color 0.3s, background 0.3s, box-shadow 0.3s, transform 0.3s;
    img {
      width: 60%;
      height: 60%;
    }
  }
  &:hover {
    cursor: pointer;
    box-shadow: 0 3px 0 hsl(200deg 47% 60%), 0 6px 0 rgba(0, 0, 0, 0.2);
    transform: translateY(3px);
  }
  &:active {
    color: gainsboro;
    background: hsl(200deg 47% 60%);
    box-shadow: 0 0 0 hsl(200deg 37% 50%), 0 0 0 rgba(0, 0, 0, 0.2);
    transform: translateY(6px);
    transition-duration: 0.1s;
  }
}
.japanese-button {
  margin: 0;
  padding-top: 14px;
  font-size: 0.8rem;
  color: #38a7f1;
}
.button__cheat {
  display: block;
  margin: 60px auto 0;
  padding: 16px 24px !important;
  border: 1px solid #38a7f1;
  color: #38a7f1;
  background-color: rgba(275, 275, 275, 0.2);
  font-size: 16px;
}
.fade-enter-active {
  transition: opacity 4s;
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}
.blurred {
  // animation: change-opacity 1s forwards;
  opacity: 15%;
}
@keyframes change-opacity {
  100% {
    opacity: 15%;
  }
}

// layout of quiz page
.box-question {
  position: relative;
  height: 100%;
  width: 100%;
}
.question-image {
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
}
// .blurred {
//   animation: change-opacity 1s forwards;
//   // opacity: 20%;
// }
@keyframes change-opacity {
  100% {
    opacity: 20%;
  }
}
.q-select-box {
  width: 100%;
  position: absolute;
  top: calc(50vh - 180px);
  left: 0;
  @media (max-width: 576px) {
    top: 120px;
  }
}
.answer-image {
  height: 60vh;
  img {
    height: 100%;
    object-fit: contain;
  }
}
.box-answer {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.fade-out {
  display: none;
}
.laugher-is {
  width: 160px;
  height: auto;
  margin-bottom: 16px;
}
.laugher-name {
  font-family: serif;
  font-size: 1.2rem;
  font-weight: bold;
  margin: 12px 0 0;
}
.click-box {
  position: fixed;
  top: calc(50vh + 100px);
  left: calc(50vw + 300px);
  @media (max-width: 992px) {
    top: calc(50vh + 40px);
    right: 30px;
    left: auto;
  }
  @media (max-width: 576px) {
    top: 50vh;
    right: 15px;
  }
  img {
    width: 160px;
    margin-left: -30px;
    margin-bottom: 20px;
    @media (max-width: 576px) {
      width: 140px;
      margin-bottom: 10px;
    }
  }
}
.click-img {
  margin-right: 0;
  margin-left: auto;
  width: 96px;
  height: 96px;
  background: url("@/assets/click-img.png") no-repeat;
  z-index: 10000;
  animation: pochi 1s steps(2) infinite;
  @media (max-width: 576px) {
    width: 60px;
    height: 60px;
    background: url("@/assets/click-img_sm.png") no-repeat;
    animation: pochi-sm 1s steps(2) infinite;
  }
}
@keyframes pochi {
  to {
    background-position-y: -192px;
  }
}
@keyframes pochi-sm {
  to {
    background-position-y: -120px;
  }
}
</style>
